import { type FC, type ReactNode } from "react";

import { Card, Status } from "@snapchat/snap-design-system";

import emptySearchSvg from "@app-assets/svg/empty-search.svg";

import { EmptySearchSvg, cardWrapper } from "./EmptyFeaturePage.styles";

interface EmptyFeaturePageProps {
    title?: ReactNode;
    children: ReactNode;
    icon?: ReactNode;
    status?: Status | null;
}

export const EmptyFeaturePage: FC<EmptyFeaturePageProps> = ({ title = "", children = "", icon, status }) => {
    return (
        <Card
            title={title}
            titleBorder={false}
            status={status === undefined ? Status.INACTIVE : status}
            className={cardWrapper}
            data-testid="empty-feature-page"
        >
            {icon ?? (
                <EmptySearchSvg
                    data-testid="empty-feature-page-icon"
                    alt="This functionality is not available"
                    src={emptySearchSvg}
                />
            )}
            {children}
        </Card>
    );
};
